import _ from 'lodash'
import {
    ActivityTypeEnum,
    DependencyData,
    TimeExpenseEntry,
    TimeExpenseEntryInput,
    ValuesFromInvoice,
    ValuesFromParent,
} from '../Timer/types-time-entry'

export const getInitialValuesForUpdate = (
    timeExpenseEntry: TimeExpenseEntry,
    dependencyData: DependencyData
) => {
    const expenseCode =
        dependencyData?.expenseCodes?.find(
            (item) => item?.id === timeExpenseEntry?.utbmsExpenseCodeId
        ) ?? undefined
    const expenseCategory =
        dependencyData?.expenseCategories?.find(
            (item) => item?.id === timeExpenseEntry?.expenseCategoryId
        ) ?? undefined
    const timeEntryCategory =
        dependencyData?.timeEntryCategories?.find(
            (item) => item?.id === timeExpenseEntry?.activityCategoryUtbmsCodeId
        ) ?? undefined
    const taskCode =
        dependencyData?.taskCodes?.find((item) => item?.id === timeExpenseEntry?.utbmsTaskCodeId) ??
        undefined

    const modifiedTaxes = [
        {
            id: '-1',
            title: 'Use tax applied to invoice',
        },
        {
            id: '0',
            title: 'Do not apply tax ',
        },
        ...dependencyData?.taxes!,
    ]
    
    const tax = modifiedTaxes?.find((item) => item?.id === timeExpenseEntry?.taxId)

    return {
        ...timeExpenseEntry,
        id: timeExpenseEntry?.id,
        expenseCode,
        expenseCategory,
        timeEntryCategory,
        taskCode,
        matter: timeExpenseEntry?.matter,
        billingCost: timeExpenseEntry?.billingCost ?? 0,
        tax: tax,
    }
}

interface TimeEntryInput {
    values: TimeExpenseEntryInput
    isExpense: boolean
    fromTimer: boolean
    valuesFromParent?: ValuesFromParent
    isMattersuiteCoCounsel?: boolean
    valuesFromInvoice?: ValuesFromInvoice
}

export const getTimeEntryInput = ({
    fromTimer,
    isExpense,
    isMattersuiteCoCounsel,
    values,
    valuesFromParent,
    valuesFromInvoice,
}: TimeEntryInput) => {
    const input = {
        ...values,
        activityType: !isExpense ? ActivityTypeEnum.Time : ActivityTypeEnum.Expense,
        matterId: values?.matter?.id,
        ...(isMattersuiteCoCounsel ? {} : { userId: values?.user?.id }),
        activityCategoryUtbmsCodeId: values?.timeEntryCategory?.id,
        utbmsType: values?.timeEntryCategory?.isUTBMSCode ? 2 : 1,
        // When expense category has the utbmsCodeId then passing that utbmsCodeId to utbmsExpenseCodeId field
        utbmsExpenseCodeId: values?.expenseCategory?.utbmsCodeId
            ? values?.expenseCategory?.utbmsCodeId
            : values?.expenseCode?.id,
        utbmsTaskCodeId: values?.taskCode?.id,
        ...(isExpense ? { taxId: values?.tax?.id } : { taxId: null }),
        resourceId: valuesFromParent?.resourceId || values?.resourceId || null,
        resourceType: valuesFromParent?.resourceType || values?.resourceType || null,
        expenseCategoryId: values?.expenseCategory?.id,
        tHoursDurationQuantity: Number(values?.tHoursDurationQuantity) ?? 0,        /**
         * Do not send rate if the user is co counsel and it's time entry
         */
        billingRate: isMattersuiteCoCounsel && !isExpense ? null : Number(values?.billingRate) ?? 0,
         /**
         * Do not send cost when it's not flat fee and user is co counsel
         */
        billingCost: isMattersuiteCoCounsel && !values.isFlat ? null :  Number(values?.billingCost) ?? 0,
        ...(!fromTimer && {
            durationInSeconds: !isExpense
                ? Math.ceil(Number(values?.tHoursDurationQuantity! * 3600))
                : null,
        }), //converting tenth hours to seconds
    }
    if (valuesFromInvoice) return input
    return _.omit(input, [
        'user',
        'matter',
        'tax',
        'taskCode',
        'timeEntryCategory',
        'expenseCategory',
        'expenseCode',
    ])
}
